import { render, staticRenderFns } from "./EditPengembalian.vue?vue&type=template&id=252e4f86&lang=pug&"
import script from "./EditPengembalian.vue?vue&type=script&lang=js&"
export * from "./EditPengembalian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports